<div class="customer-area content-section flex-grow-1" *ngIf="!isBusy">
  <div class="flex flex-wrap grid-gap-15" style="align-items: center">
    <div class="camera-box">
      <div
        *ngIf="!!customerInfo?.logo; else noImage"
        class="image"
        style="background-image: url({{ customerInfo.logo }});
            background-size: contain; background-repeat: no-repeat; border: 1px solid grey;"
      ></div>
      <ng-template #noImage>
        <span class="grey-circle">
          <i class="fa fa-camera"></i>
        </span>
      </ng-template>
    </div>

    <div
      class="flex-grow-1 customer-details"
      style="height: 100%; display: flex; align-items: center"
    >
      <div>
        <table style="width: 100%">
          <tr>
            <td>
              <div>
                <span class="content-header">
                  {{ customerInfo?.name }}
                </span>
              </div>
              <div style="font-size: 14px; font-weight: 400; color: var(--grey-700)">Customer</div>
            </td>
            <td style="text-align: right; white-space: nowrap">
              <span *ngIf="customerInfo?.inactive" class="inactive-state">
                <span class="state-wrapper inactive-ball"></span> deactivated
              </span>
              <span *ngIf="!customerInfo?.inactive" class="active-state">
                <span class="state-wrapper active-ball"></span> activated
              </span>
            </td>
          </tr>
        </table>

        <div style="margin-left: 2px; margin-top: 15px">
          <div class="mb-2">
            <span style="font-size: 14px; font-weight: bold">Account details</span>
            <span class="edit-contact link-style" (click)="initEditAccountDetails()"
              >edit <i class="fa fa-pencil"></i
            ></span>
          </div>
          <div
            class="mb-2"
            style="
              height: 40px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              line-height: 1.2em;
            "
            [pTooltip]="customerInfo.description"
          >
            {{ customerInfo.description }}
          </div>
          <div class="mb-2 flex">
            <div>
              <i class="fa fa-user grey-icon"></i> Account Manager:
              <span class="account-detail">{{ customerInfo.accountManagerName }}</span>
            </div>
            <div>
              <i class="fa fa-users grey-icon"></i> Active Users:
              <span class="account-detail">{{ customerInfo.activeUserCount }} users</span>
            </div>
            <div>
              <i class="fa fa-phone grey-icon"></i> Number:
              <span class="account-detail" style="color: var(--engineius-blue)"
                >{{ customerInfo.phoneNumber }}
                <span
                  *ngIf="customerInfo.organisationPhoneNumbers?.length > 0"
                  class="link-style"
                  style="margin-left: 5px"
                  (click)="initEditAccountDetails()"
                >
                  (+{{ customerInfo.organisationPhoneNumbers?.length }} more)
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showEditDetails"
  [modal]="true"
  header="Edit Account Details"
  [responsive]="true"
  [style]="{ width: '600px' }"
  [closable]="false"
>
  <form [formGroup]="editForm" *ngIf="editForm" (ngSubmit)="saveEditForm()">
    <input type="hidden" name="id" formControlName="id" />
    <div class="grid-gap-15" style="display: grid; grid-template-columns: 180px 1fr">
      <div>
        <div class="account-detail-header">Description</div>
        <div class="account-detail-sub">1024 max characters.</div>
      </div>

      <div>
        <div class="input-group">
          <div class="input-group-item">
            <textarea
              pInputTextarea
              formControlName="description"
              class="filter-input-container"
              placeholder="Customer description"
              required
              style="width: 100%; height: 100px"
              maxlength="1024"
            ></textarea>
          </div>
        </div>
      </div>

      <div>
        <div class="account-detail-header">Account Manager</div>
      </div>

      <div>
        <div class="input-group">
          <div class="input-group-item">
            <p-dropdown
              [options]="userOptions"
              formControlName="accountManagerUserId"
              class="input-group-filter filter-dropdown"
              [style]="{ width: '100%' }"
              appendTo="body"
              [filter]="true"
            ></p-dropdown>
          </div>
        </div>
      </div>

      <div class="account-detail-header">Organisation Numbers</div>

      <div>
        <div class="mb-2">
          <div *ngIf="customerInfo?.phoneNumber">
            {{ customerInfo.phoneNumber }}
            <span style="font-size: 0.8em; margin-left: 5px; vertical-align: top">(Primary)</span>
          </div>

          <span class="add-number link-style small-text text-right" (click)="addNewPhone()">
            + Add Number
          </span>
        </div>

        <div formArrayName="phoneNumbers">
          <div *ngFor="let item of phoneNumbers.controls; let index = index" class="mb-2">
            <div
              [formGroupName]="index"
              style="display: flex; align-items: center; position: relative; width: 100%"
            >
              <input
                pInputText
                formControlName="telephone"
                placeholder=""
                style="flex-grow: 1"
                class="filter-input-container"
                (blur)="onPhoneNumberAdded(index, $event)"
              />
              <input type="hidden" formControlName="id" />
              <span
                style="
                  color: red;
                  cursor: pointer;
                  font-size: 1.5em;
                  position: absolute;
                  right: 10px;
                  top: 10px;
                "
                pTooltip="Remove image"
                (click)="deletePhone(index)"
              >
                <i class="fa fa-trash-o"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p-footer>
      <div class="text-right">
        <button
          tabindex="1"
          class="ui-button ui-button-tertiary mr-2"
          pButton
          label="Cancel"
          data-action="cancel"
          (click)="showEditDetails = false"
          [tabIndex]="-1"
        ></button>
        <button
          class="ui-button ui-button-primary"
          pButton
          label="Save"
          type="submit"
          [tabIndex]="1"
        ></button>
      </div>
    </p-footer>
  </form>
</p-dialog>

<p-confirmDialog></p-confirmDialog>

<!--<p-dialog-->
<!--  [(visible)]="showEditDetails"-->
<!--  [modal]="true"-->
<!--  header="Edit Account Details"-->
<!--  [responsive]="true"-->
<!--  [style]="{ width: '600px' }"-->
<!--&gt;-->
<!--  <form [formGroup]="editForm" *ngIf="editForm">-->
<!--    <input type="hidden" name="id" formControlName="id" />-->
<!--    <div class="grid-gap-35" style="display: grid; grid-template-columns: 140px 1fr">-->
<!--      <div>-->
<!--        <div>Description</div>-->
<!--        <div style="color: #808080; font-size: 11px">1024 max characters.</div>-->
<!--      </div>-->

<!--      <div>-->
<!--        <div class="input-group">-->
<!--          <div class="input-group-item">-->
<!--            <textarea-->
<!--              pInputTextarea-->
<!--              formControlName="description"-->
<!--              class="filter-input-container"-->
<!--              placeholder="Customer description"-->
<!--              required-->
<!--              style="width: 100%; height: 100px"-->
<!--              maxlength="1024"-->
<!--            ></textarea>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div>-->
<!--        <div>Account Manager</div>-->
<!--      </div>-->

<!--      <div>-->
<!--        <div class="input-group">-->
<!--          <div class="input-group-item">-->
<!--            <p-dropdown-->
<!--              [options]="userOptions"-->
<!--              formControlName="accountManagerUserId"-->
<!--              class="input-group-filter filter-dropdown"-->
<!--              [style]="{ width: '100%' }"-->
<!--              appendTo="body"-->
<!--              [filter]="true"-->
<!--            ></p-dropdown>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div>&nbsp;</div>-->
<!--      <div class="">-->
<!--        <div formArrayName="phoneNumbers">-->
<!--          <div *ngFor="let item of phoneNumbers.controls; let index = index">-->
<!--            <div [formGroupName]="index" class="edit-value mb-2" style="position: relative">-->
<!--              <input-->
<!--                pInputText-->
<!--                formControlName="telephone"-->
<!--                placeholder="Input number"-->
<!--                style="width: 100%"-->
<!--              />-->
<!--              <input type="hidden" formControlName="id" />-->
<!--              <span-->
<!--                *ngIf="index == 0"-->
<!--                class="add-number link-style small-text text-right"-->
<!--                (click)="addNewPhone()"-->
<!--              >-->
<!--                + Add Number-->
<!--              </span>-->
<!--              <span-->
<!--                *ngIf="index != 0"-->
<!--                class="add-number link-style small-text text-right"-->
<!--                (click)="deletePhone(index)"-->
<!--              >-->
<!--                Delete-->
<!--              </span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="text-right">-->
<!--      <button-->
<!--        class="ui-button ui-button-tertiary mr-2"-->
<!--        pButton-->
<!--        label="Cancel"-->
<!--        (click)="showEditDetails = false"-->
<!--      ></button>-->
<!--      <button-->
<!--        class="ui-button ui-button-primary"-->
<!--        pButton-->
<!--        label="Save"-->
<!--        (click)="saveEditForm()"-->
<!--      ></button>-->
<!--    </div>-->
<!--  </form>-->
<!--</p-dialog>-->
